<template lang="pug">
  v-dialog(persistent :max-width="modelOptions.dialogMaxWidth" :value="model" )
    v-card
      v-card-text
        v-layout(column v-if="modelTitle")
          v-flex.mb-4
            span.title {{ modelTitle }}
        v-layout(row wrap align-center).pa-0.ma-0
          v-flex(shrink).px-2
            v-progress-circular(
              :size="modelOptions.progressSize"
              :width="modelOptions.progressWidth"
              :color="modelOptions.progressColor"
              indeterminate
            )
          v-flex(grow v-if="modelText").px-2
            span.body-1 {{ modelText }}
</template>

<script>
import * as constants from './constants';

export default {
  props: {
    value: {
      type: Boolean,
      default: undefined
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    // if overlay should be opaque
    opaque: {
      type: Boolean,
      default: undefined
    },
    // store opts
    namespace: {
      type: String,
      default: constants.NAMESPACE
    }
  },
  computed: {
    model () {
      if (typeof this.value !== 'undefined') return this.value;
      const state = this.$store ? this.$store.state[this.namespace] : {};
      return state.loading;
    },
    modelTitle () {
      if (typeof this.title !== 'undefined') return this.title;
      const state = this.$store ? this.$store.state[this.namespace] : {};
      return state.title;
    },
    modelText () {
      if (typeof this.text !== 'undefined') return this.text;
      const state = this.$store ? this.$store.state[this.namespace] : {};
      return state.text;
    },
    modelOptions () {
      if (typeof this.options !== 'undefined') return this.options;
      const state = this.$store ? this.$store.state[this.namespace] : {};
      return Object.assign({
        dialogMaxWidth: 250,
        progressColor: 'primary',
        progressSize: 45,
        progressWidth: 5
      }, state.options);
    },
    containerClass () {
      const state = this.$store ? this.$store.state[this.namespace] : {};
      const opaque = typeof this.opaque !== 'undefined' ? this.opaque : state.opaque;
      return {
        white: opaque
      };
    }
  }
};
</script>
